import questionsReducer from "./questions";
import { combineReducers } from "redux";

const rootReducer= combineReducers({
  questions : questionsReducer,
});

export default rootReducer; 